function VirtualizedBodyRow(_ref) {
  var data = _ref.data,
      index = _ref.index,
      style = _ref.style,
      key = _ref.key,
      isScrolling = _ref.isScrolling;
  var rows = data.rows,
      rowRenderer = data.renderer.rowRenderer;
  var rowData = rows[index];
  return rowRenderer(rowData, {
    style: style,
    index: index,
    rowIndex: index,
    key: key
  }, {
    // eslint-disable-next-line no-underscore-dangle
    rowIndex: index,
    isScrolling: isScrolling
  });
}

export default VirtualizedBodyRow;
//# sourceMappingURL=VirtualizedBodyRow.js.map
